import { useMemo } from 'react';

import { Typography } from '@mui/material';
import { Box, styled } from '@mui/system';
import { format, isToday } from 'date-fns';
import { useTranslation } from 'react-i18next';

const ColumnBox = styled(Box)`
    display: flex;
    flex-direction: column;
    text-align: center;
` as typeof Box;

export type MeetingInfoProps = {
    className?: string;
    classTimes?: string;
};

const MeetingInfo = (props: MeetingInfoProps) => {
    const { className, classTimes } = props;
    const { t } = useTranslation('sign-up');
    const displayTime = useMemo(() => {
        if (!classTimes) return null;
        const timesArray = classTimes?.split(','); // classTimes = "1705316280:1705319880,1705402680:1705406280,1705489080:1705492680,1705575480:1705579080,"

        const upcomingTime = timesArray?.find((time) => {
            // find the time based on the second in the time that has not ended yet(is later than now)
            const times = time.split(':');
            const endTimestamp = times[1];
            const endDate = new Date(parseInt(endTimestamp, 10) * 1000);

            return endDate > new Date();
        });

        if (!upcomingTime) {
            return;
        }

        const times = upcomingTime.split(':');
        const startTimestamp = times[0];
        const endTimestamp = times[1];

        const startDate = new Date(parseInt(startTimestamp, 10) * 1000);
        const endDate = new Date(parseInt(endTimestamp, 10) * 1000);

        if (isToday(startDate)) {
            return `${t('today')}, ${format(startDate, 'h:mm aa')}\u00A0–\u00A0${format(endDate, 'h:mm aa')}`;
        }

        return `${format(startDate, 'EEEE, MMMM d, h:mm aa')}–${format(endDate, 'h:mm aaaa')}`;
    }, [classTimes, t]);

    if (!className) {
        return null;
    }

    return (
        <ColumnBox>
            {className && (
                <Typography variant="h4" color="gray">
                    {className}
                </Typography>
            )}

            {displayTime && (
                <Typography variant="body1" color="gray" sx={{ textAlign: 'center' }}>
                    {displayTime}
                </Typography>
            )}
        </ColumnBox>
    );
};
export default MeetingInfo;
